export const CartActionTypes = {
    FETCH_CART_REQUEST: "FETCH_CART_REQUEST",
    FETCH_CART_SUCCESS: "FETCH_CART_SUCCESS",
    FETCH_CART_FAILURE: "FETCH_CART_FAILURE",
    ADD_CARTS: "ADD_CARTS",
    REMOVE_FROM_CARTS: "REMOVE_FROM_CARTS",
};
